export const IsLoggedOutKey = 'is-logged-out';
export const IsLoggedInKey = 'is-logged-in';
export const IdpProviderKey = 'idp-provider';
export const TokenSyncStatusKey = 'token-sync-status';
export const TokenSyncStatusHeaderKey = 'X-TOKEN-SYNC-STATUS';
export const AdminTokenKey = 'admin_token';
export const AdminTokenHeaderKey = 'X-ADMIN-TOKEN';
export const FeatureFlagAccessTokenKey = 'feature_flag_access_token';
export const FeatureFlagAccessTokenHeaderKey = 'X-FEATURE-FLAG-ACCESS-TOKEN';
export const FeatureFlagAccessTokenParamKey = 'accessToken';
export const FeatureFlagAccessTokenAttributeKey = 'accessToken';

export type IdpProvider = 'cognito' | 'descope' | 'otp';

// IDP Provider values
export const IDP_PROVIDER = {
  COGNITO: 'cognito',
  DESCOPE: 'descope',
  OTP: 'otp',
} as const;

export const refreshTokenUrl = '/authentication/refresh-token';
export const logoutUrl = '/authentication/logout';
